<template>
  <div v-if="isMounted" :key="route" class="loader">
    <div class="vx-row" v-if="dataReady">
      <component
        :is="fName.type"
        v-for="(fName,fIndex) in settings.data"
        :key="fIndex"
        :index="fIndex"
        :settings="fName"
      ></component>
    </div>
  </div>
</template>

<script>
// import AdvanceTable from "./advance_table.vue";

import { mapGetters } from "vuex";

import { alertMixin } from "../../mixin/alertMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
import { helperMixin } from "../../mixin/helperMixin";
import { dbSettingsMixin } from "./dbSettingsMixin";

import statistics from "../../components/aron/dashboard_items/statistics/statistics.vue";
import statisticsiconright from "../../components/aron/dashboard_items/statistics/statisticsIconRight.vue";
import standard from "../../components/aron/dashboard_items/statistics/standard.vue";
import activityMonitor from "../../components/aron/dashboard_items/statistics/activityMonitor.vue";
import gridTable from "../../components/aron/dashboard_items/grid/gridTable.vue";
import caseTracker from "../../components/aron/dashboard_items/statistics/caseTracker.vue";
import horizontalBarChart from "../../components/aron/dashboard_items/chart/horizontalBarChart.vue";

export default {
  components: {
    statistics,
    statisticsiconright,
    horizontalBarChart,
    standard,
    activityMonitor,
    caseTracker,
    gridTable,
  },
  mixins: [dbSettingsMixin, alertMixin, axiosMixin, helperMixin],
  watch: {
    $route(to, from) {
      this.route = this.$route.params.subject;
      this.currentView = "list"; //reset the view
    }
  },
  methods: {},
  data() {
    return {
      route: this.$route.params.subject,
      isMounted: false,
      currentView: "list",
      dataReady: false,
      settings: {}
    };
  },
  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo"
    })
  },
  methods: {
    startLoading(id) {
      console.log("loading ID:", id);
      this.$vs.loading({
        container: "." + id,
        scale: 0.6
      });
    },
    stopLoading(id) {
      this.$vs.loading.close("." + id + " > .con-vs-loading");
    },
    getData() {
      // this.startLoading("loader");
      console.log("settings:", this.settings);
      this.aronPost(this.settings.endPoint, this.settings.filter, "", "")
        .then(response => {
          if (response.status == 200) {
            console.log("responssse:", response);

            this.updateItemInObject(
              this.settings.data,
              "dataName",
              "value",
              response.data.values
            );
            console.log("settings after:", this.settings.data);
            this.dataReady = true;
          }

          // this.stopLoading("loader");
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
          //  this.stopLoading("loader");
        });
    }
  },
  created() {
    this.dataReady = false;
  },
  mounted() {
    this.settings = this.getDashboard(this.route);
    console.log("this.settings in main:", this.settings);
    this.isMounted = true;
    this.getData();
  }
};
</script>